@if (loggedIn$ | async) {
  <otg-sidenav [logoPath]="(logoPath$ | async) || undefined">
    <!-- Loaded on first open: the chat stack is too heavy for the initial bundle. -->
    <div copilot class="copilot-host">
      @defer (when copilot.isOpen()) {
        <otg-copilot-drawer></otg-copilot-drawer>
      }
    </div>
    <otg-security-prompt></otg-security-prompt>
    <router-outlet></router-outlet>
  </otg-sidenav>
  <!-- The co-pilot is full-screen on phones; the bottom nav would cover its composer. -->
  @if (((locations$ | async)?.length || 0) > 0 && !copilot.isOpen()) {
    <otg-bottom-nav></otg-bottom-nav>
  }
  <otg-copilot-fab></otg-copilot-fab>
} @else {
  @if (loggedIn$ | async) {
    <otg-security-prompt></otg-security-prompt>
  }
  <router-outlet></router-outlet>
}
